

















import { Vue, Component, Prop, Watch, Emit, Ref } from "vue-property-decorator";
import { Getter, Mutation } from "vuex-class";
import SelectMerchantModal from "./components/select-modal/index.vue";
import Home from "./views/home/index.vue";
import store from "./store";
import BaseApp from "./extension/BaseApp.vue";
import NewOrderModal from "./components/new-order-modal/index.vue";
import { os } from "./libs/utils";
// import FastClick from "fastclick";

@Component({
  name: "App",
  components: {
    Home,
    SelectMerchantModal,
    NewOrderModal
  }
})
export default class App extends BaseApp {
  @Getter("showLoading") showLoading!: boolean;
  @Getter("showSelectMerchantModal") showSelectMerchantModal!: boolean;
  @Getter("showNewOrderModal") showNewOrderModal!: boolean;
  mounted() {
    const merchId = this.$store.getters.merchId;
    // 转场动画配合 fastClick 不起作用
    // FastClick.attach(document.body);
  }
}
